export default __webpack_public_path__ + "bc1428b9d246f2f6d06755f92c355773.png";